const AddReaction: React.FC<{ color?: string }> = ({ color = "#121C2D" }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 0.5C15.2761 0.5 15.5 0.723858 15.5 1V3.5H18C18.2761 3.5 18.5 3.72386 18.5 4C18.5 4.27614 18.2761 4.5 18 4.5H15.5V7C15.5 7.27614 15.2761 7.5 15 7.5C14.7239 7.5 14.5 7.27614 14.5 7V4.5H12C11.7239 4.5 11.5 4.27614 11.5 4C11.5 3.72386 11.7239 3.5 12 3.5H14.5V1C14.5 0.723858 14.7239 0.5 15 0.5Z"
      fill={color}
    />
    <path
      d="M1.5 10C1.5 5.85786 4.85786 2.5 9 2.5C9.31793 2.5 9.63101 2.51975 9.93813 2.55805C10.2122 2.59222 10.462 2.39778 10.4962 2.12376C10.5303 1.84974 10.3359 1.59991 10.0619 1.56574C9.7138 1.52233 9.35939 1.5 9 1.5C4.30558 1.5 0.5 5.30558 0.5 10C0.5 14.6944 4.30558 18.5 9 18.5C13.6944 18.5 17.5 14.6944 17.5 10C17.5 9.72386 17.2761 9.5 17 9.5C16.7239 9.5 16.5 9.72386 16.5 10C16.5 14.1421 13.1421 17.5 9 17.5C4.85786 17.5 1.5 14.1421 1.5 10Z"
      fill={color}
    />
    <path
      d="M6 8.75C6.41421 8.75 6.75 8.35825 6.75 7.875C6.75 7.39175 6.41421 7 6 7C5.58579 7 5.25 7.39175 5.25 7.875C5.25 8.35825 5.58579 8.75 6 8.75Z"
      fill={color}
    />
    <path
      d="M12.75 7.875C12.75 8.35825 12.4142 8.75 12 8.75C11.5858 8.75 11.25 8.35825 11.25 7.875C11.25 7.39175 11.5858 7 12 7C12.4142 7 12.75 7.39175 12.75 7.875Z"
      fill={color}
    />
    <path
      d="M5.19302 11.6053C5.41037 11.4363 5.72334 11.4748 5.89321 11.6912L5.89848 11.6976C5.90411 11.7044 5.91408 11.7162 5.92838 11.7323C5.95702 11.7645 6.00285 11.8137 6.06581 11.8745C6.19195 11.9961 6.38532 12.1622 6.64537 12.3294C7.1635 12.6625 7.94604 13 8.99999 13C10.0539 13 10.8365 12.6625 11.3546 12.3294C11.6147 12.1622 11.808 11.9961 11.9342 11.8745C11.9971 11.8137 12.043 11.7645 12.0716 11.7323C12.0859 11.7162 12.0959 11.7044 12.1015 11.6976L12.1067 11.6913C12.2766 11.475 12.5896 11.4363 12.807 11.6053C13.0249 11.7749 13.0642 12.089 12.8947 12.307L12.5 12C12.8947 12.307 12.8947 12.307 12.8947 12.307L12.894 12.3078L12.8933 12.3087L12.8915 12.3111L12.8865 12.3173L12.8711 12.3361C12.8585 12.3513 12.8412 12.3717 12.819 12.3966C12.7747 12.4465 12.7112 12.5144 12.6283 12.5943C12.4628 12.7539 12.2187 12.9628 11.8954 13.1706C11.2468 13.5875 10.2794 14 8.99999 14C7.72061 14 6.75315 13.5875 6.10461 13.1706C5.78133 12.9628 5.5372 12.7539 5.37167 12.5943C5.2888 12.5144 5.22526 12.4465 5.18098 12.3966C5.15882 12.3717 5.14145 12.3513 5.12885 12.3361L5.11352 12.3173L5.10853 12.3111L5.1067 12.3087L5.10595 12.3078C5.10595 12.3078 5.10532 12.307 5.49999 12L5.10532 12.307C4.93578 12.089 4.97505 11.7749 5.19302 11.6053Z"
      fill={color}
    />
  </svg>
);

export default AddReaction;
